<div class="gpd-full-page gpd-container microtask-page" style="padding: 0px">
  <div class="gpd-container-header">
    <dx-text-box
      i18n-placeholder="@@microtasksSearch"
      placeholder="Search microtasks..."
      mode="search"
      class="gpd-input"
      width="300px"
      (onValueChanged)="microtasksDataGrid.instance.searchByText($event.value)"
    ></dx-text-box>
    <div class="gpd-button-group">
      <app-gpd-button
        (onClick)="addRow($event); clearEditingData()"
        icon="add"
        i18n-text="@@addNewMicrotaskCaps"
        text="ADD NEW MICROTASK"
      ></app-gpd-button>
    </div>
  </div>
  <dx-data-grid
    #microtasksDataGrid
    [dataSource]="microTasks"
    (onCellPrepared)="handleRowPrepared($event)"
    keyExpr="id"
    class="gpd-datagrid"
    (onEditingStart)="onEditInit($event)"
    (onRowInserted)="onRowAdded($event)"
    [allowColumnResizing]="true"
    [columnResizingMode]="'widget'"
    [columnAutoWidth]="false"
    [showBorders]="true"
    [scrolling]="{ mode: 'standard', useNative: true }"
    width="100%"
    height="100%"
    [rowAlternationEnabled]="true"
    [hoverStateEnabled]="true"
  >
    <dxo-editing mode="form" [confirmDelete]="false">
      <dxo-form colCount="1">
        <dxi-item template="microTaskForm">
          <div *dxTemplate="let item of 'microTaskForm'">
            <form (submit)="$event.preventDefault(); saveChanges($event)">
              <dx-form [(formData)]="editingData" [colCount]="1" validationGroup="microTaskForm">
                <dxi-item itemType="group" [colCount]="2">
                  <dxi-item dataField="title" editorType="dxTextBox" caption="Title">
                    <dxo-label i18n-text text="Title" />
                    <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item dataField="taskPackageId" template="parentTaskEditCellTemplate" [isRequired]="true">
                    <dxo-label i18n-text="@@taskPackage" text="Task Package" />
                    <div *dxTemplate="let item of 'parentTaskEditCellTemplate'">
                      <dx-select-box
                        [(value)]="editingData.taskPackageId"
                        [dataSource]="taskPackages"
                        valueExpr="id"
                        displayExpr="name"
                      >
                        <dx-validator>
                          <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                        </dx-validator>
                      </dx-select-box>
                    </div>
                  </dxi-item>

                  <dxi-item dataField="type" template="typeEditCellTemplate">
                    <dxo-label i18n-text="@@type" text="Type" />
                    <div *dxTemplate="let item of 'typeEditCellTemplate'">
                      <dx-select-box
                        [(value)]="editingData.type"
                        [dataSource]="typeList"
                        valueExpr="value"
                        displayExpr="text"
                        (onValueChanged)="onTypeValueChanged($event, item)"
                      >
                      </dx-select-box>
                    </div>
                    <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    dataField="documentFolderId"
                    template="documentFolderCellTemplate"
                    [visible]="documentFolderVisible"
                  >
                    <dxo-label i18n-text="@@destinationFolder" text="Destination Folder" />
                    <div *dxTemplate="let item of 'documentFolderCellTemplate'">
                      <dx-select-box
                        [(value)]="editingData.documentFolderId"
                        [dataSource]="documentFolderList"
                        valueExpr="id"
                        displayExpr="name"
                      >
                      </dx-select-box>
                    </div>
                    <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item dataField="documentName" editorType="dxTextBox" [visible]="documentFolderVisible">
                    <dxo-label i18n-text="@@documentName" text="Document Name" />
                    <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item
                    dataField="templateFilename"
                    template="templateFileTemplate"
                    [visible]="documentFolderVisible"
                  >
                    <dxo-label i18n-text="@@templateDocument" text="Template Document" />
                    <div *dxTemplate="let item of 'templateFileTemplate'">
                      <ng-container class="gt-flex-dir-row">
                        <input
                          type="file"
                          *ngIf=" editingData.templateFilename === null"
                          (change)=" onTemplateFileChanged( $event, editingData ) "
                        />

                        <div class="gt-flex-width">
                          <dx-button
                            *ngIf=" editingData.templateFilename != null"
                            #templateFile
                            i18n-text
                            [text]="viewFileText + editingData.templateFilename"
                            [ariaReadOnly]="true"
                            [disabled]="enableViewFile"
                            class="gt-button gt-btn-right gt-blk-txt add-site-icon"
                            icon="folder"
                            (onClick)="getTemplateFile( editingData.templateFilename,editingData)"
                          >
                          </dx-button>

                          <dx-button
                            *ngIf=" editingData.templateFilename != null"
                            #templateFile
                            i18n-text
                            width="250px"
                            text="Delete"
                            class="gt-button gt-btn-right gt-blk-txt add-site-icon"
                            icon="clear"
                            (onClick)="deleteTemplateFile( editingData.id, editingData.templateFilename,editingData)"
                          >
                          </dx-button>
                        </div>
                      </ng-container>
                    </div>
                  </dxi-item>

                  <dxi-item
                    dataField="userDefinedFields"
                    template="userDefinedOptionsEditCellTemplate"
                    [visible]="userDefinedSelectionVisible"
                  >
                    <dxo-label i18n-text="@@userDefinedSelection" text="User Defined Selection" />
                    <div *dxTemplate="let item of 'userDefinedOptionsEditCellTemplate'">
                      <dx-tag-box
                        [(value)]="editingData.userDefinedFields"
                        [acceptCustomValue]="true"
                        [openOnFieldClick]="false"
                        (onValueChanged)="editingData.setValue($event.value)"
                      >
                      </dx-tag-box>
                    </div>
                    <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item dataField="departmentId" template="departmentIdCellTemplate">
                    <dxo-label i18n-text="@@departmentId" text="Department" />
                    <div *dxTemplate="let item of 'departmentIdCellTemplate'">
                      <dx-select-box
                        [(value)]="editingData.departmentId"
                        [dataSource]="departments"
                        valueExpr="id"
                        displayExpr="name"
                      >
                      </dx-select-box>
                    </div>
                    <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item dataField="priority" template="priorityCellTemplate" [visible]="priorityVisible">
                    <dxo-label i18n-text="@@priority" text="Priority" />
                    <div *dxTemplate="let item of 'priorityCellTemplate'">
                      <div class="priority-container">
                        <dx-select-box
                          [(value)]="editingData.priority"
                          [dataSource]="priorityList"
                          displayExpr="text"
                          (onValueChanged)="item.setValue($event.value)"
                          valueExpr="id"
                        ></dx-select-box>
                      </div>
                    </div>
                    <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
                  </dxi-item>

                  <dxi-item dataField="validationRequired" template="validationRequiredEditCellTemplate">
                    <dxo-label i18n-text="@@validationRequired" text="Validation Required" />
                    <div *dxTemplate="let item of 'validationRequiredEditCellTemplate'">
                      <dx-check-box
                        [(value)]="editingData.validationRequired"
                        (onValueChanged)="changeRequiresValidation($event, item)"
                        (onInitialized)="changeValidation(item)"
                      ></dx-check-box>
                    </div>
                    <!--   <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
                  </dxi-item>
                </dxi-item>

                <dxi-item
                  itemType="group"
                  [colCountByScreen]="{ sm: 2, md: 2 }"
                  cssClass="buttons-group"
                  [verticalAlignment]="true"
                >
                  <dx-button
                    i18n-text="@@cancel"
                    text="Cancel"
                    stylingMode="contained"
                    icon="close"
                    class="gpd-button-secondary"
                    [useSubmitBehavior]="false"
                    (onClick)="onEditCanceling()"
                  ></dx-button>

                  <dx-button
                    i18n-text="@@save"
                    text="CONFIRM"
                    stylingMode="contained"
                    validationGroup="microTaskForm"
                    icon="check"
                    [useSubmitBehavior]="true"
                    class="gpd-button"
                  ></dx-button>
                </dxi-item>
              </dx-form>
            </form>
          </div>
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxi-column i18n-caption="@@title" caption="Title" dataField="title">
      <!--   <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
    </dxi-column>

    <dxi-column i18n-caption="@@type" caption="Type" dataField="type">
      <dxo-lookup [dataSource]="typeList" displayExpr="text" valueExpr="value"></dxo-lookup>
      <!--       <div *dxTemplate="let item of 'typeEditCellTemplate'">
        <dx-select-box [(value)]="item.data.type" [dataSource]="typeList" valueExpr="taskTypeEnglish"
          displayExpr="taskTypeLocalized" (onValueChanged)="onTypeValueChanged($event); item.setValue($event.value)">
        </dx-select-box>
      </div>
      <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
    </dxi-column>

    <dxi-column
      [visible]="false"
      [allowEditing]="true"
      i18n-caption="@@destinationFolder"
      caption="Destination Folder"
      dataField="documentFolderId"
    >
      <dxo-lookup [dataSource]="documentFolderList" displayExpr="name" valueExpr="id"> </dxo-lookup>
      <!--   <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
    </dxi-column>

    <dxi-column
      [visible]="false"
      [allowEditing]="true"
      i18n-caption="@@documentName"
      caption="Document Name"
      dataField="documentName"
    >
      <!-- <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
    </dxi-column>

    <dxi-column
      [visible]="false"
      [allowEditing]="true"
      i18n-caption="@@templateDocument"
      caption="Template Document"
      dataField="templateDocument"
    >
      <dxo-lookup [dataSource]="documentFolderList" displayExpr="name" valueExpr="id"> </dxo-lookup>
      <!--       <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule>
      <div *dxTemplate="let item of 'templateFileTemplate'" style="height: 34px">
        <ng-container class="gt-flex-dir-row">
          <div class="dx-field-value">
            <input type="file" (change)=" onTemplateFileChanged( $event.target.files[0], item ) " />
            <ng-template #templateFile>
              <div style="
                  display: felx;
                  width: 100%;
                  justify-content: space-evenly;
                ">
                <dx-button [disabled]="true" *ngIf="item.data.isUploaded === false"
                  [text]="viewFIleText + item.data.templateFilename"> </dx-button>

                <dx-button *ngIf="item.data.isUploaded !== false" #templateFile i18n-text
                  [text]=" viewFIleText + item.data.templateFilename " [ariaReadOnly]="true"
                  (onClick)="getTemplateFile(item.templateFilename,item)">
                </dx-button>

                <dx-button *ngIf="item.data.isUploaded !== false" #templateFile i18n-text text="delete"
                  (onClick)="deleteTemplateFile(item.data.taskId,item.data.templateFilename,item)">
                </dx-button>
              </div>
            </ng-template>
          </div>
        </ng-container>
      </div> -->
    </dxi-column>

    <dxi-column
      [visible]="false"
      i18n-caption="@@userDefinedSelection"
      caption="User Defined Selection"
      dataField="userDefinedFields"
    >
      <!--       <div *dxTemplate="let item of 'userDefinedOptionsEditCellTemplate'">
        <dx-tag-box [(value)]="item.data.userDefinedFields" [acceptCustomValue]="true" [openOnFieldClick]="false"
          (onValueChanged)="item.setValue($event.value)">
        </dx-tag-box>
      </div>
      <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
    </dxi-column>

    <dxi-column i18n-caption="@@departmentId" caption="Department" dataField="departmentId">
      <dxo-lookup [dataSource]="departments" valueExpr="id" displayExpr="name"></dxo-lookup>
      <!--       <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
    </dxi-column>

    <dxi-column dataField="taskPackageId" i18n-caption="@@taskPackage" caption="Task Package">
      <dxo-lookup [dataSource]="taskPackages" valueExpr="id" displayExpr="name"></dxo-lookup>
    </dxi-column>

    <dxi-column
      i18n-caption="@@priority"
      alignment="left"
      caption="Priority"
      dataField="priority"
      cellTemplate="priorityCellTemplate"
    >
      <div *dxTemplate="let item of 'priorityCellTemplate'">
        <div *ngIf="item.data.type != 'group'" class="priority-container">
          <app-priority-pill
            [value]="item.data.priority"
            [editable]="!(item.data.status == 2 || item.data.status == 4)"
          />
        </div>
      </div>
      <!--       <div *dxTemplate="let item of 'priorityEditCellTemplate'">
        <div class="priority-container">
          <dx-select-box [(value)]="item.data.priority" [dataSource]="priorityList" displayExpr="text"
            (onValueChanged)="item.setValue($event.value)" valueExpr="id"></dx-select-box>
        </div>
      </div>
      <dxi-validation-rule type="required" i18n-message="@@required"></dxi-validation-rule> -->
    </dxi-column>

    <dxi-column
      i18n-caption="@@validationRequired"
      caption="Validation Required"
      dataField="validationRequired"
      [visible]="false"
    >
      <!--       <div *dxTemplate="let item of 'validationRequiredEditCellTemplate'">
        <dx-check-box [(value)]="item.data.validationRequired" (onValueChanged)="changeRequiresValidation($event, item)"
          (onInitialized)="changeValidation(item)"></dx-check-box>
      </div> -->
    </dxi-column>

    <dxi-column
      dataField=""
      allowEditing="false"
      cellTemplate="buttonCellTemplate"
      [width]="68"
      [formItem]="{visible: false}"
    >
      <div *dxTemplate="let item of 'buttonCellTemplate'">
        <div class="cell-with-buttons">
          <div class="cell-button-container">
            <dx-button icon="edit" class="cell-button" (onClick)="editMicroTask(item)"></dx-button>
            <dx-button icon="clear" class="cell-button" (onClick)="initDeleteMicrotask(item.data)"></dx-button>
          </div>
        </div>
      </div>
    </dxi-column>
  </dx-data-grid>
</div>

<app-delete-popup
  [visible]="deletePopupVisible"
  (onAbort)="deletePopupVisible = false"
  (onConfirm)="deleteMicroTask($event)"
  i18n-message
  message="Do you want to delete this microtask?"
></app-delete-popup>

<dx-toast [visible]="toastVisible" [type]="type" message="{{message}}" position="bottom center" width="fit-content">
</dx-toast>
